import { Component, OnInit, Input } from '@angular/core';
import { StatusbarComponent } from '../../menu/statusbar/statusbar.component';
import { MenuService } from '../../../../services/menu.service';
import { DataIoService } from '../../../../services/data-io.service';
import { ConfigService } from '../../../../services/config.service';
import { MenuNode, SensorSet, BaseSensor } from '../../../../classes';
import { TranslationService } from '../../../../services/translation.service';

@Component({
    selector: 'screen-idle',
    templateUrl: './idle.component.html',
    styleUrls: ['./idle.component.scss'],
    standalone: false
})
export class IdleComponent implements OnInit {
	@Input('debug') debug: boolean = false;
	_unit: string = "AICI_UNIT_CELSIUS";
	_value: string = "22.0";
	get value() {
		return this.indoorTempSensor.getCurrentValue();
	}
	get unit() {
		return this.indoorTempSensor.getUnit();
	}

	outdoorTempSensor: BaseSensor;
	indoorTempSensor: BaseSensor;
	humiditySensor: BaseSensor;
	desiredTemp: BaseSensor;
	vorlaufTemp: BaseSensor;
	pressureSensor: BaseSensor;
	dhwTempSensor: BaseSensor;
	hasOutdoorTempSensor: boolean = true;
	hasHumiditySensor: boolean = true;

	get serviceCompany(): string {

		if (this.ioService.getContactName() && this.ioService.getContactName().length > 0) {
			return this.ioService.getContactName();
		} else {
			return this.translator.tr('OTX_MAINTENANCE_3_STANDARD_NAME');
		}
	}

	get servicePhoneNumber(): string {
		return this.ioService.getContactPhone();

	}

	getTranslator(): TranslationService {
		return this.translator;
	}

	getIoService(): DataIoService {
		return this.ioService;
	}
	hasDHW() {
		return this.dhwTempSensor != undefined && !this.ioService.getConfiguration().simulatorConfig.hasSensoDIRECT();
	}
	getDHWValue() {
		let s = this.ioService.deviceInfo().getScale('d006');
		let dis = (this.ioService.deviceInfo().getRawValue('ai_mode_dhw') == 'OFF' || s.getCurrentValue() <= 29);
		if (dis) {
			return this.translator.tr(this.dhwTempSensor.getSpecialValue(29).getReplacement());
		}
		let val = this.dhwTempSensor.getCurrentValue();
		if (this.dhwTempSensor.hasSpecialValue(val)) {
			return this.translator.tr(this.dhwTempSensor.getSpecialValue(val).getReplacement());
		} else {
			return this.dhwTempSensor.toString();
		}


	}
	hasHeating() {
		let sc = this.ioService.getConfiguration().simulatorConfig;
		return (this.vorlaufTemp != undefined) && !sc.witterungsgefuehrt() && !sc.hasSensoDIRECT() && !sc.hasControl();
	}
	getHeatingValue() {
		let s = this.ioService.deviceInfo().getHeatingCircuitById(1).getScale('vorlaufsolltemp');

		let dis = (this.ioService.deviceInfo().getRawValue('ai_mode_heading') == 'OFF' || s.getCurrentValue() <= 29);
		if (dis) {
			return this.translator.tr(this.dhwTempSensor.getSpecialValue(29).getReplacement());
		}
		let val = s.getCurrentValue();
		if (s.hasSpecialValue(val)) {
			return this.translator.tr(s.getSpecialValue(val).getReplacement());
		} else {
			return s.toString();
		}
	}
	constructor(private menuService: MenuService, private ioService: DataIoService, private config: ConfigService, private translator: TranslationService) {
		this.hasOutdoorTempSensor = true; //(this.ioService.getConfiguration().simulatorConfig.has('outdoor-temperature-sensor'));
		this.hasHumiditySensor = (this.ioService.getConfiguration().simulatorConfig.has('humidity-sensor'));
		this.dhwTempSensor = (this.ioService.deviceInfo().getScale('d006'));
		this.outdoorTempSensor = this.ioService.sensors.getTemperatureSensor('outdoor');/*
		if (!this.ioService.getConfiguration().simulatorConfig.isStandalone()) {
			this.outdoorTempSensor = this.ioService.sensors.getTemperatureSensor('outdoor');
		} else {
			this.hasOutdoorTempSensor = (this.outdoorTempSensor != undefined);
		}*/
		this.indoorTempSensor = this.ioService.sensors.getTemperatureSensor('room_temperature');
		this.desiredTemp = this.ioService.getCurrentNominalTemperatureSensor();
		this.humiditySensor = this.ioService.sensors.getHumiditySensor('humidity');
		this.vorlaufTemp = this.ioService.deviceInfo().getHeatingCircuit(1).getScale('vorlaufisttemp');
		this.pressureSensor = this.ioService.deviceInfo().getScale('waterpressure');
	}
	eventSubscription: any;
	ngOnInit() {
		this.debugOut("OnInit");
		this.eventSubscription = this.ioService.inputs.events$.subscribe(
			(event) => { this.eventHandler(event); }
		);
	}

	serviceDateExpired() {
		return this.ioService.serviceDateExpired();
	}
	ngOnDestroy() {
		this.debugOut("onDestroy");
		this.eventSubscription.unsubscribe();
	}

	debugOut(msg: string): void {
		if (this.debug) {
			console.log("IdleComponent: " + msg);
		}
	}
	eventHandler(event) {
		this.debugOut("Handling Event: " + event);
		switch (event) {
			case 'down': {
				break;
			}
			case 'up': {

				break;
			}
			case 'confirm': {

				break;
			}
			case 'menu': {
				this.menuService.goto('dashboard');
				break;
			}
			case 'back': {
				break;
			}
			default: {

			}
		}
	}
}
